/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAppDeviceResponseDto } from '../models/work-app-device-response-dto';
import { WorkCreateAppDeviceDto } from '../models/work-create-app-device-dto';

@Injectable({ providedIn: 'root' })
export class WorkAppDevicesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appDevicesV1ControllerRegisterOrUpdate()` */
  static readonly AppDevicesV1ControllerRegisterOrUpdatePath = '/v1/app-devices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appDevicesV1ControllerRegisterOrUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appDevicesV1ControllerRegisterOrUpdate$Response(
    params: {
      body: WorkCreateAppDeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAppDeviceResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAppDevicesService.AppDevicesV1ControllerRegisterOrUpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAppDeviceResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appDevicesV1ControllerRegisterOrUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appDevicesV1ControllerRegisterOrUpdate(
    params: {
      body: WorkCreateAppDeviceDto
    },
    context?: HttpContext
  ): Observable<WorkAppDeviceResponseDto> {
    return this.appDevicesV1ControllerRegisterOrUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAppDeviceResponseDto>): WorkAppDeviceResponseDto => r.body)
    );
  }

}
